import API from 'constants/API';

import {AxiosResponse} from 'axios';
import {createPostDTO, getPubPostsDto, updatePostDto} from 'typescript/dto/postsDto';
import ApiData from 'typescript/interfaces/ApiData';
import {IPost} from 'typescript/models/Post';
import {queryBuilder} from 'utils/helpers/queryBuilder';
import httpClient from 'utils/httpClient/httpClient';

export const createPost = (dto: createPostDTO): Promise<AxiosResponse<ApiData<IPost>>> => {
  return httpClient.post(API.POSTS_SERVICE.BASE, {post: dto});
};

export const getPubPosts = (dto: getPubPostsDto): Promise<AxiosResponse<ApiData<IPost[]>>> => {
  const query = queryBuilder({
    baseQuery: `${API.PUB_SERVICE.BASE}/${dto.pub_id}/posts`,
    queryObject: {
      'filter[favorite]': dto.filters?.favorite,
      'filter[by_date]': dto.filters?.date,
      'filter[social_network_kind]': dto.filters?.postFormat,
      page: dto.page,
      per_page: dto.perPage,
    },
  });

  return httpClient.get(query);
};

export const updatePost = ({
  id,
  changes,
}: {
  id: IPost['id'];
  changes: updatePostDto;
}): Promise<AxiosResponse<ApiData<IPost>>> => {
  return httpClient.put(`${API.POSTS_SERVICE.BASE}/${id}`, {post: changes});
};
